const services = [
  {
    name: "3D Printing",
    link: "3D-Printing",
  },
  {
    name: "Laser Cutting",
    link: "Laser-Cutting",
  },
  {
    name: "PCB Manufacturing",
    link: "PCB-Manufacturing",
  },
  {
    name: "Product Development",
    link: "Product-Development",
  },
  {
    name: "Silicon Molding",
    link: "Silicon-Molding",
  },
];

export default services;
